<template>
  <div>
    <loadingCube v-if="!loading_company" :loadingMessage="'COMPANY'"></loadingCube>
    <div v-else class="record">
      <b-tabs v-model="company_record_tabIndex" pills vertical>
        <template v-slot:tabs-start>
          <div class="record_info">
            <h2 class="font-weight-bold bp_color mb-0">{{ company.company_name }}</h2>
            <h3>{{ company.rel_profile.ltd_reg_number }}</h3>
            <p class="b3_color mb-0"><strong>Type:</strong> {{ company.company_type }}</p>
            <p class="b3_color mb-0"><strong>Ref:</strong> {{ company.internal_finance_ref }}</p>
            <p class="b3_color mb-0" v-if="company.primary_consultant_id !== null">
              <strong><i class="fas fa-user-tie"></i></strong> {{ company.primary_consultant.first_name }} {{ company.primary_consultant.surname }}
            </p>
            <hr>
            <div v-if="company.rel_profile.office_phone_id !== null"><strong><i class="fas fa-phone-alt"></i></strong>{{ company.rel_profile.office_phone.phone_number }}</div>
            <div v-if="company.rel_profile.office_email_id !== null"><strong><i class="fas fa-at"></i></strong>
              <a :href="'mailto:' + company.rel_profile.office_email.email_addres" class="email_link">{{ company.rel_profile.office_email.email_address }}</a></div>
            <div v-if="company.rel_profile.office_website !== null"><strong><i class="fas fa-desktop"></i></strong>
              <a :href="'http://' + company.rel_profile.office_website" class="email_link">{{ company.rel_profile.office_website }}</a></div>
          </div>
        </template>

        <b-tab title="Addresses & Contacts" lazy>
          <b-card-text>
            <addresses_contacts :addresses="addresses" :contacts="contacts"></addresses_contacts>
          </b-card-text>
        </b-tab>
        <b-tab title="Company Information" lazy>
          <b-card-text>
            <pre_agreement v-if="notEmptyObject(company)" :company="company" :pre_agreement="pre_agreement" :credit_finance="credit_finance"
                           :payment_process_info="payment_process_info" :referral_rebate="referral_rebate"></pre_agreement>
          </b-card-text>
        </b-tab>
<!--        <b-tab title="Compliance Check" lazy disabled>-->
<!--          <b-card-text>-->
<!--            Compliance Check-->
<!--          </b-card-text>-->
<!--        </b-tab>-->
<!--        <b-tab title="Accounts & Payment" lazy :title-link-class="check_pre_agreement_class" :disabled="check_pre_agreement">-->
<!--          <b-card-text>-->
<!--            <accounts_payment v-if="notEmptyObject(company)" :company="company" :pre_agreement="pre_agreement" :payment_process_info="payment_process_info"-->
<!--                              :referral_rebate="referral_rebate" :credit_finance="credit_finance"></accounts_payment>-->
<!--          </b-card-text>-->
<!--        </b-tab>-->

        <b-tab title="Timesheet Auth & Login" lazy :title-link-class="check_signed_contract_class" :disabled="check_signed_contract">
          <b-card-text>
            <timesheet_auth_logins v-if="notEmptyObject(company)" :default_timesheet_auth="default_timesheet_auth" :default_timesheet_auth_loaded="default_timesheet_auth_loaded"
                                   :contacts="contacts" :company="company"></timesheet_auth_logins>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Accounts_payment from "pages/companies/record/accounts_payment";
import Pre_agreement from "pages/companies/record/pre_agreement";
import Addresses_contacts from "pages/companies/record/addresses_contacts";
import timesheet_auth_logins from "pages/companies/record/timesheet_auth_logins";
import loadingCube from "loaders/record_loader";

export default {
  name: "c_company_record",
  components: {
    Accounts_payment,
    Pre_agreement,
    Addresses_contacts,
    timesheet_auth_logins,
    loadingCube,
  },
  data() {
    return {
      company_record_tabIndex: this.$store.state.companies.current_record_tab_index,

      company_id: '',

      // current signed in crm user details
      user: this.$store.state.auth.me,

      loading_company: false,
      company: {},

      addresses_loaded: false,
      addresses: [],
      emails_loaded: false,
      emails: [],
      phones_loaded: false,
      phones: [],
      banks_loaded: false,
      banks: [],
      credit_finance_loaded: false,
      credit_finance: [],
      payment_process_info_loaded: false,
      payment_process_info: [],
      referral_rebate_loaded: false,
      referral_rebate: [],
      relationship_loaded: false,
      relationship: [],
      services_loaded: false,
      services: [],
      contracts_loaded: false,
      contracts: [],
      health_check_loaded: false,
      health_check: [],
      sent_health_check_loaded: false,
      sent_health_check: [],
      pre_agreement_loaded: false,
      pre_agreement: [],
      sent_pre_agreement_loaded: false,
      sent_pre_agreement: [],

      contacts_loaded: false,
      contacts: [],

      notes_loaded: false,
      notes: [],
      activity_loaded: false,
      activity: [],

      orders_loaded: false,
      orders: [],

      default_timesheet_auth_loaded: false,
      default_timesheet_auth: {},
    }
  },
  computed: {
    /**
     * TAB CHECKS ----------------------------------------------------------
     */
    check_pre_agreement() {
      if (this.notEmptyObject(this.pre_agreement) && this.notEmptyObject(this.payment_process_info)) {
        return !(this.check_utr_and_payment_process_info_null_values() && this.check_payment_process_info_fee_margin_agreed()
            && this.check_pre_agreement_payroll_payment_terms() && this.check_pre_agreement_recruitment_partnership());
      }
      else {
        return true
      }
    },
    check_pre_agreement_class() {
      if (this.notEmptyObject(this.pre_agreement) && this.notEmptyObject(this.payment_process_info)) {
        if (this.check_utr_and_payment_process_info_null_values() && this.check_payment_process_info_fee_margin_agreed()
            && this.check_pre_agreement_payroll_payment_terms() && this.check_pre_agreement_recruitment_partnership()) {
          return ''
        }
        else {
          return 'tab_unavailable'
        }
      }
      else {
        return 'tab_unavailable'
      }
    },

    check_signed_contract() {
      if (this.notEmptyObject(this.contracts)) {
        return !this.check_contract_is_signed();
      }
      else {
        return true;
      }
    },
    check_signed_contract_class() {
      if (this.notEmptyObject(this.contracts)) {
        if (this.check_contract_is_signed()) {
          return '';
        }
        else {
          return 'tab_unavailable'
        }
      }
      else {
        return 'tab_unavailable'
      }
    },
  },
  async beforeMount() {
    let companyId = this.company_id;

    if(this.$route.query.company_id){
      companyId = this.$route.query.company_id;
      this.company_id = companyId;
    }
    else{
      let company = await axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show');
      this.company_id = company.data.id;
    }

    await this.get_company_data();
  },
  watch: {
    /**
     * RELOADS ----------------------------------------------------------
     */
    company_record_tabIndex(tab) {
      this.$store.commit('SET_COMPANY_TAB_INDEX', tab);
    },
  },
  methods: {
    /**
     * CHECK PRE AGREEMENT INFO COMPLETE ----------------------------------------------------------
     */
    check_utr_and_payment_process_info_null_values() {
      // TODO -- && this.accounts_info.pay_period_day !== null
      // this.company.rel_profile.utr_number !== null &&
      return this.company.rel_profile.utr_status !== null
          && this.payment_process_info.pay_cycle !== null
          && this.payment_process_info.pay_week_end_day !== null
          && this.payment_process_info.pay_instruction_day !== null
          && this.payment_process_info.pay_client_payment_day !== null
          && this.payment_process_info.pay_worker_payment_day !== null
          && this.payment_process_info.pay_worker_payment_time !== null
          && this.payment_process_info.pay_worker_text_day !== null
          && this.payment_process_info.payroll_solution_id !== null
          && this.payment_process_info.min_vat_percentage_worked_to !== null;
    },
    check_payment_process_info_fee_margin_agreed() {
      if (this.payment_process_info.fee_margin_agreed) {
        return this.payment_process_info.fee_margin_type !== null && this.payment_process_info.fee_margin_amount !== null;
      }
      else {
        return false
      }
    },
    check_pre_agreement_payroll_payment_terms() {
      // if (this.payment_process_info.payroll_require_payment_terms === false) {
      //   return true
      // }
      // else {
      //   return this.payment_process_info.payroll_payment_terms_length !== null && this.payment_process_info.payroll_payment_terms_type !== null &&
      //       this.payment_process_info.payroll_payment_terms_value !== null;
      // }
    },
    check_pre_agreement_recruitment_partnership() {
      if (this.payment_process_info.recruitment_partnership === false) {
        return true
      }
      else {
        return this.payment_process_info.recruitment_partnership_fee_type !== null && this.payment_process_info.recruitment_partnership_fee_value !== null;
      }
    },
    /**
     * CHECK CONTRACT SIGNED ----------------------------------------------------------
     */
    check_contract_is_signed() {
      let is_signed = false;
      for (let i = 0; i < this.contracts.length; i++) {
        if (this.contracts[i].is_signed === true) {
          is_signed = true;
        }
      }
      return is_signed;
    },
    /**
     * GETTING COMPANY INFORMATION ----------------------------------------------------------
     */
    get_company_data() {
      return new Promise((complete) => {
        axios.get(this.crmApiPath + 'company/' + this.company_id).then(company => {
          this.company = company.data;

          let company_promises = [];
          company_promises.push(new Promise(resolve => this.get_company_addresses().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_emails().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_phones().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_banks().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_credit_finance().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_payment_process_info().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_referral_rebate().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_relationships().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_services().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_contracts().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_health_check().then(() => resolve())));
          // company_promises.push(new Promise(resolve => this.get_company_sent_health_checks().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_pre_agreement().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_sent_pre_agreements().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_contacts().then(() => resolve())));
          // company_promises.push(new Promise(resolve => this.get_company_notes().then(() => resolve())));
          // company_promises.push(new Promise(resolve => this.get_company_logs().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_default_ts_auth().then(() => resolve())));
          company_promises.push(new Promise(resolve => this.get_company_orders().then(() => resolve())));

          Promise.all(company_promises).then(() => {
            this.loading_company = true;
            complete();
          });
        });
      });
    },

    // Related company data
    get_company_addresses() {
      return axios.get(this.crmApiPath + 'contact_info/address/company/' + this.company_id).then(addresses => {
        this.addresses = addresses.data;
        this.addresses_loaded = true;
      });
    },
    get_company_emails() {
      return axios.get(this.crmApiPath + 'contact_info/email/company/' + this.company_id).then(emails => {
        this.emails = emails.data;
        this.emails_loaded = true;
      });
    },
    get_company_phones() {
      return axios.get(this.crmApiPath + 'contact_info/phone/company/' + this.company_id).then(phones => {
        this.phones = phones.data;
        this.phones_loaded = true;
      });
    },
    get_company_banks() {
      return axios.get(this.crmApiPath + 'company/bank/company/' + this.company_id).then(banks => {
        this.banks = banks.data;
        this.banks_loaded = true;
      });
    },
    get_company_credit_finance() {
      return axios.get(this.crmApiPath + 'company/credit_finance/company/' + this.company_id).then(credit_finance => {
        this.credit_finance = credit_finance.data;
        this.credit_finance_loaded = true;
      });
    },
    get_company_payment_process_info() {
      return axios.get(this.crmApiPath + 'company/payment_process_info/company/' + this.company_id).then(payment_process_info => {
        this.payment_process_info = payment_process_info.data;
        this.payment_process_info_loaded = true;
      });
    },
    get_company_referral_rebate() {
      return axios.get(this.crmApiPath + 'company/referral_rebate/company/' + this.company_id).then(referral_rebate => {
        this.referral_rebate = referral_rebate.data;
        this.referral_rebate_loaded = true;
      });
    },
    get_company_relationships() {
      return axios.get(this.crmApiPath + 'company/relationship/company/' + this.company_id).then(relationship => {
        this.relationship = relationship.data;
        this.relationship_loaded = true;
      });
    },
    get_company_services() {
      return axios.get(this.crmApiPath + 'company/services/company/' + this.company_id).then(services => {
        this.services = services.data;
        this.services_loaded = true;
      });
    },
    get_company_contracts() {
      return axios.get(this.crmApiPath + 'company/contract/company/' + this.company_id).then(contracts => {
        this.contracts = contracts.data;
        this.contracts_loaded = true;
      })
    },
    get_company_health_check() {
      return axios.get(this.crmApiPath + 'company/health_check/company/' + this.company_id).then(health_check => {
        this.health_check = health_check.data;
        this.health_check_loaded = true;
      });
    },
    get_company_sent_health_checks() {
      return axios.get(this.crmApiPath + 'company/sent_health_check/company/' + this.company_id).then(sent_health_check => {
        this.sent_health_check = sent_health_check.data;
        this.sent_health_check_loaded = true;
      });
    },
    get_company_pre_agreement() {
      return axios.get(this.crmApiPath + 'company/pre_agreement/company/' + this.company_id).then(pre_agreement => {
        this.pre_agreement = pre_agreement.data;
        this.pre_agreement_loaded = true;
      });
    },
    get_company_sent_pre_agreements() {
      return axios.get(this.crmApiPath + 'company/sent_pre_agreement/company/' + this.company_id).then(sent_pre_agreement => {
        this.sent_pre_agreement = sent_pre_agreement.data;
        this.sent_pre_agreement_loaded = true;
      });
    },
    get_company_contacts() {
      return axios.get(this.crmApiPath + 'contact/company/' + this.company_id).then(contacts => {
        this.contacts = contacts.data;
        this.contacts_loaded = true;
      })
    },
    get_company_orders() {
      return axios.get(this.crmApiPath + 'order/job/company/index/' + this.company_id).then(client_orders => {
        this.orders = client_orders.data;
      });
    },
    get_company_default_ts_auth() {
      return axios.get(this.crmApiPath + 'timesheet_authorisation/client/get/' + this.company_id + '?require_user=false').then(ts_auth => {
        this.default_timesheet_auth = ts_auth.data;
        this.default_timesheet_auth_loaded = true;
      })
    },
  }
}
</script>

<style lang="scss">
.tab_unavailable {
  color: $red !important;

  &::before {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content:     "\f071   ";
  }
}

</style>
